document.addEventListener("DOMContentLoaded", function () {
    const passwordInputs = document.querySelectorAll(".show_password_input");
    const toggleButtons = document.querySelectorAll(".show_password");

    if (passwordInputs.length && toggleButtons.length) {
        toggleButtons.forEach((toggleButton, index) => {
            const passwordInput = passwordInputs[index];
            if (passwordInput) {
            toggleButton.addEventListener("click", function () {
                const isPassword = passwordInput.getAttribute("type") === "password";
                passwordInput.setAttribute("type", isPassword ? "text" : "password");
            });
            }
        });
    }
});
document.addEventListener("DOMContentLoaded", function() {
  var params = new URLSearchParams(window.location.search);
  var targetId = params.get("goto");
  if (targetId) {
    var targetElem = document.getElementById(targetId);
    if (targetElem) {
      setTimeout(function() {
        // Calculate the offset position
        var width = window.innerWidth;
        if(width >= 767)
          var headerOffset = 0; // height in px of your sticky header + extra margin
        else
          var headerOffset = 30; // height in px of your sticky header + extra margin
        var elementPosition = targetElem.getBoundingClientRect().top;
        var offsetPosition = elementPosition + window.scrollY - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      }, 100);
    }
  }
});
// document.addEventListener('DOMContentLoaded', function() {
//   function customProductGallerySlider(){
//     $('.product-slider').not('.slick-initialized').each(function() {
//         $(this).slick({
//         dots: true,
//         arrows: false,          // set true to show prev/next arrows
//         infinite: false,
//         speed: 400,
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         autoplay: false,
//         autoplaySpeed: 2500,
//         adaptiveHeight: false,
//         });
//       $('div.custom-product-slider').removeClass('hidden');
//     });
//   }
//   customProductGallerySlider();
// });
document.addEventListener('DOMContentLoaded', function() {
  function customProductGallerySlider() {
    $('.product-slider').not('.slick-initialized').each(function() {
      $(this).slick({
        dots: true,
        arrows: false,
        infinite: false,
        speed: 400,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 2500,
        adaptiveHeight: false,
      });
      $(this).find('.custom-product-slider').removeClass('hidden');
    });
  }

  function refreshCardSliders() {
    $('.product-slider.slick-initialized').slick('setPosition');
  }

  customProductGallerySlider();

  $(window).on('load', function() {
    refreshCardSliders();
    setTimeout(refreshCardSliders, 250);
  });

  var resizeTimer;
  $(window).on('resize orientationchange', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(refreshCardSliders, 250);
  });

  if ('ResizeObserver' in window) {
    var roTimer;
    var ro = new ResizeObserver(function() {
      clearTimeout(roTimer);
      roTimer = setTimeout(refreshCardSliders, 100);
    });
    document.querySelectorAll('.product-slider').forEach(function(el) {
      ro.observe(el);
    });
  }
});
document.addEventListener("DOMContentLoaded", function () {
  const links = document.querySelectorAll("a[href]");

  links.forEach(link => {
    const href = link.getAttribute("href");

    // Ignore anchors, mailto, tel, javascript links
    if (
      href.startsWith("#") ||
      href.startsWith("mailto:") ||
      href.startsWith("tel:") ||
      href.startsWith("javascript:")
    ) {
      return;
    }

    const linkUrl = new URL(href, window.location.origin);

    // Check if external link
    if (linkUrl.hostname !== window.location.hostname) {
      if (!link.hasAttribute("target")) {
        link.setAttribute("target", "_blank");
        link.setAttribute("rel", "noopener noreferrer");
      }
    }
  });
});